import { useCallback, useEffect, useState } from 'react';

import useUnsplash from './useUnsplash';

const usePaginatedUnsplash = (variables: { query: string; perPage?: number }) => {
  const [data, setData] = useState<Array<any>>([]);
  const [page, setPage] = useState(1);

  useEffect(() => {
    setData([]);
    setPage(1);
  }, [variables.query, variables.perPage]);

  const {
    fetching,
    error,
    data: currentPageData,
  } = useUnsplash({
    ...variables,
    page,
  });

  const hasNextPage = currentPageData.length === variables.perPage; // assuming a next page is present unless lesser data than requested returned

  useEffect(() => {
    setData((prevData) => {
      return [...prevData, ...currentPageData];
    });
  }, [currentPageData]);

  const fetchMore = useCallback(() => {
    setPage((prevPage) => prevPage + 1);
  }, []);

  return {
    data: data,
    initialFetching: data.length === 0 ? fetching : false,
    fetching,
    error,
    fetchMore: hasNextPage ? fetchMore : undefined,
  };
};

export default usePaginatedUnsplash;
